import Helper from './Helper/Helper';
export default {
	install(Vue) {
		Vue.filter('arabic', (input) => {
			return Helper.toArabic(input)
		})
	}
}
